module.exports = ""


//////////////////
// WEBPACK FOOTER
// ./src/app/side-nav/header/header.component.css
// module id = ./src/app/side-nav/header/header.component.css
// module chunks = main